import { render, staticRenderFns } from "./RefinementList.vue?vue&type=template&id=25025c1e&scoped=true"
import script from "./RefinementList.vue?vue&type=script&lang=js"
export * from "./RefinementList.vue?vue&type=script&lang=js"
import style0 from "./RefinementList.vue?vue&type=style&index=0&id=25025c1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25025c1e",
  null
  
)

export default component.exports